var $body = $('body');
var searchOverlayTemplate = $('#search-overlay-template').html();

function searchOverlayShow(actionIcon, windowHeight, headerHeight) {
    $body
        .css({
            'height': windowHeight,
            'overflow': 'hidden'
        })
        .append(searchOverlayTemplate);
    $('#search-overlay').css('top', headerHeight + ($('.advertising').height() || 0)).fadeIn(200, function() {
        actionIcon.removeClass('fa-search').addClass('fa-times');
    });
    $('#search-overlay-inner').css('padding-top', $('#search-overlay-search').outerHeight() + 40);
}

function searchOverlayHide(actionIcon) {
    $('#search-overlay').fadeOut(200, function() {
        $(this).remove();
        $body
            .css({
                'height': '',
                'overflow': ''
            });
        actionIcon.removeClass('fa-times').addClass('fa-search');
    });

}

$(document).on('keyup', function(e) {
    if ($('#search-overlay').is(':visible') && e.keyCode == 27) {
        var actionIcon = $('#search-overlay-toggle').find('.fa');
        searchOverlayHide(actionIcon);
    }
    return false;
});

$('#search-overlay-toggle').on('click', function() {
    var actionIcon = $(this).find('.fa');
    var windowHeight = $(window).height();
    var headerHeight = $('#header').outerHeight();

    if ($('#search-overlay').length) {
        searchOverlayHide(actionIcon);
    } else {
        searchOverlayShow(actionIcon, windowHeight, headerHeight);
    }

    return false;
});